module.exports = __webpack_public_path__ + "static/media/upstox.9f9cee67.gif";